module.exports = __webpack_public_path__ + "overview-a5b6df21/marker-f51deabcdc3bdc9fe2742984d45f4907.svg";